import { request } from './utils';

// Roles are fixed in P4 / Rolify — no endpoint to fetch them, so the list
// lives here (was previously hard-coded in the DPP user controller).
const STATIC_ROLES = ['admin', 'api', 'cs', 'daily_processing_read', 'daily_processing_write', 'ach_admin', 'user_admin', 'dealer_browser'];

export default class UserService {
    static async getAll() {
        const response = await request('/api/users');
        // P4 returns { users: [...] }; preserve the shape call-sites expect.
        return { users: response.data?.users };
    }

    static async getRoles() {
        return { roles: STATIC_ROLES };
    }

    static async newUser(user) {
        const response = await request('/api/users', {
            method: 'POST',
            data: JSON.stringify({ user })
        });
        return response;
    }

    static async updateActiveUser(id, active) {
        const response = await request(`/api/users/${id}`, {
            method: 'PATCH',
            data: JSON.stringify({ user: { active } })
        });
        return response;
    }

    // rolesUpdateData is { id, roles }
    static async updateUserRoles(rolesUpdateData) {
        const { id, roles } = rolesUpdateData;
        const response = await request(`/api/users/${id}`, {
            method: 'PATCH',
            data: JSON.stringify({ user: { roles } })
        });
        return response;
    }

    static async unlockUser(id) {
        const response = await request(`/api/users/${id}/unlock`, {
            method: 'POST'
        });
        return response;
    }
}
